<c-modal alignment="center" [visible]="display" (visibleChange)="onDisplayChange($event)">
  <c-modal-header>
    <h5 cModalTitle>Calendar Events</h5>
    <button cButtonClose (click)="display = false"></button>
  </c-modal-header>
  <c-modal-body>
    <div class="table-responsive">      
      <table class="table table-striped">
        <thead>
          <tr>
            <th></th>
            <th>Name</th>
            <th>Start Time</th>
            <th>End Time</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let event of events">
            @let media = event.media;
            <tr [style.border-left]="'4px solid ' + event.color" (click)="onEventClick(event)">
              <td style="padding: 0px; margin: 0px; vertical-align: middle; xtext-align: center; width: 108px;">
                @let thumbnail = media?.cover?.src;
                @if (!!thumbnail) {
                  <img [src]="thumbnail | serverAuthUrl" alt="Event thumbnail" class="thumbnail" />
                } @else {
                  <span>-</span>
                }
              </td> 
              <td>{{ event.name }}</td>
              <td>{{ formatDate(event.timeFrom) }}</td>
              <td>{{ formatDate(event.timeTo) }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </c-modal-body>
  <c-modal-footer>
    <button cButton color="secondary" (click)="display = false">Close</button>
  </c-modal-footer>
</c-modal>